import { Colors } from '@/common/colors/colors';
import { DIRECT_SECTION_LABEL } from '../constants/pageSearch.constants';

const SECTION_COLORS = [
	Colors.darkBlue,
	Colors.orange,
	Colors.green,
	Colors.purple,
	Colors.red,
	Colors.violet,
	Colors.darkGray2,
];
const TINT_ALPHA = '22';

const TITLE_PREFIX_SCORE = 30;
const TITLE_WORD_SCORE = 20;
const TITLE_MATCH_SCORE = 10;
const SECTION_MATCH_SCORE = 5;
const DETAILS_MATCH_SCORE = 2;

export const getSearchItems = (navigationConfig, checkAccess) =>
	navigationConfig
		.filter((section) => checkAccess(section.access))
		.flatMap((section) =>
			section.list
				? section.list
						.filter((element) => checkAccess(element.access))
						.map((element) => ({ ...element, section: section.name }))
				: [{ ...section, section: DIRECT_SECTION_LABEL }],
		);

export const getTokens = (query) =>
	query.toLowerCase().split(/\s+/).filter(Boolean);

const getTokenScore = (item, token) => {
	const name = item.name.toLowerCase();

	if (name.startsWith(token)) {
		return TITLE_PREFIX_SCORE;
	}
	if (name.split(/\s+/).some((word) => word.startsWith(token))) {
		return TITLE_WORD_SCORE;
	}
	if (name.includes(token)) {
		return TITLE_MATCH_SCORE;
	}
	if (item.section.toLowerCase().includes(token)) {
		return SECTION_MATCH_SCORE;
	}
	return `${item.description || ''} ${item.link}`.toLowerCase().includes(token)
		? DETAILS_MATCH_SCORE
		: 0;
};

const getItemScore = (item, tokens) => {
	let total = 0;

	for (const token of tokens) {
		const score = getTokenScore(item, token);

		if (!score) {
			return 0;
		}
		total += score;
	}

	return total;
};

export const filterSearchItems = (items, query, section) => {
	const tokens = getTokens(query);
	const inSection = section
		? items.filter((item) => item.section === section)
		: items;

	if (tokens.length === 0) {
		return inSection;
	}

	return inSection
		.map((item) => ({ item, score: getItemScore(item, tokens) }))
		.filter((entry) => entry.score > 0)
		.sort((a, b) => b.score - a.score)
		.map((entry) => entry.item);
};

export const groupSearchItems = (items) => {
	const groups = [];

	items.forEach((item) => {
		const group = groups.find((element) => element.section === item.section);

		if (group) {
			group.items.push(item);
		} else {
			groups.push({ section: item.section, items: [item] });
		}
	});

	return groups;
};

export const getSectionChips = (items) =>
	groupSearchItems(items).map((group) => ({
		section: group.section,
		count: group.items.length,
	}));

export const getHighlightParts = (text, tokens) => {
	if (tokens.length === 0) {
		return [{ text, match: false }];
	}

	const escaped = tokens.map((token) =>
		token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
	);
	const regex = new RegExp(`(${escaped.join('|')})`, 'gi');

	return text
		.split(regex)
		.filter(Boolean)
		.map((part) => ({
			text: part,
			match: tokens.includes(part.toLowerCase()),
		}));
};

export const getSectionColor = (sections, section) =>
	SECTION_COLORS[
		Math.max(sections.indexOf(section), 0) % SECTION_COLORS.length
	];

export const getTint = (color) => `${color}${TINT_ALPHA}`;
